/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Status_CreatedInputs */

const en_admin_payments_status_created = /** @type {(inputs: Admin_Payments_Status_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const zh_admin_payments_status_created = /** @type {(inputs: Admin_Payments_Status_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已创建`)
};

/**
* | output |
* | --- |
* | "Created" |
*
* @param {Admin_Payments_Status_CreatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_status_created = /** @type {((inputs?: Admin_Payments_Status_CreatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Status_CreatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_status_created(inputs)
	return zh_admin_payments_status_created(inputs)
});
export { admin_payments_status_created as "admin.payments.status_created" }